export default {
    props: {
        legendAlign: {
            type: String,
            kComposite: 'legend.align'
        }, 
        legendBackground: {
            type: String,
            kComposite: 'legend.background'
        }, 
        legendBorderColor: {
            type: String,
            kComposite: 'legend.border.color'
        }, 
        legendBorderDashType: {
            type: String,
            kComposite: 'legend.border.dashType'
        }, 
        legendBorderWidth: {
            type: Number,
            kComposite: 'legend.border.width'
        }, 
        legendHeight: {
            type: Number,
            kComposite: 'legend.height'
        }, 
        legendInactiveItemsLabelsColor: {
            type: String,
            kComposite: 'legend.inactiveItems.labels.color'
        }, 
        legendInactiveItemsLabelsFont: {
            type: String,
            kComposite: 'legend.inactiveItems.labels.font'
        }, 
        legendInactiveItemsLabelsTemplate: {
            type: String | Function,
            kComposite: 'legend.inactiveItems.labels.template'
        }, 
        legendItemCursor: {
            type: String,
            kComposite: 'legend.item.cursor'
        }, 
        legendItemVisual: {
            type: Function,
            kComposite: 'legend.item.visual'
        }, 
        legendLabelsColor: {
            type: String,
            kComposite: 'legend.labels.color'
        }, 
        legendLabelsFont: {
            type: String,
            kComposite: 'legend.labels.font'
        }, 
        legendLabelsMargin: {
            type: Number,
            kComposite: 'legend.labels.margin'
        }, 
        legendLabelsMarginBottom: {
            type: Number,
            kComposite: 'legend.labels.margin.bottom'
        }, 
        legendLabelsMarginLeft: {
            type: Number,
            kComposite: 'legend.labels.margin.left'
        }, 
        legendLabelsMarginRight: {
            type: Number,
            kComposite: 'legend.labels.margin.right'
        }, 
        legendLabelsMarginTop: {
            type: Number,
            kComposite: 'legend.labels.margin.top'
        }, 
        legendLabelsPadding: {
            type: Number,
            kComposite: 'legend.labels.padding'
        }, 
        legendLabelsPaddingBottom: {
            type: Number,
            kComposite: 'legend.labels.padding.bottom'
        }, 
        legendLabelsPaddingLeft: {
            type: Number,
            kComposite: 'legend.labels.padding.left'
        }, 
        legendLabelsPaddingRight: {
            type: Number,
            kComposite: 'legend.labels.padding.right'
        }, 
        legendLabelsPaddingTop: {
            type: Number,
            kComposite: 'legend.labels.padding.top'
        }, 
        legendLabelsTemplate: {
            type: String | Function,
            kComposite: 'legend.labels.template'
        }, 
        legendMargin: {
            type: Number,
            kComposite: 'legend.margin'
        }, 
        legendMarginBottom: {
            type: Number,
            kComposite: 'legend.margin.bottom'
        }, 
        legendMarginLeft: {
            type: Number,
            kComposite: 'legend.margin.left'
        }, 
        legendMarginRight: {
            type: Number,
            kComposite: 'legend.margin.right'
        }, 
        legendMarginTop: {
            type: Number,
            kComposite: 'legend.margin.top'
        }, 
        legendOffsetX: {
            type: Number,
            kComposite: 'legend.offsetX'
        }, 
        legendOffsetY: {
            type: Number,
            kComposite: 'legend.offsetY'
        }, 
        legendOrientation: {
            type: String,
            kComposite: 'legend.orientation'
        }, 
        legendPadding: {
            type: Number,
            kComposite: 'legend.padding'
        }, 
        legendPaddingBottom: {
            type: Number,
            kComposite: 'legend.padding.bottom'
        }, 
        legendPaddingLeft: {
            type: Number,
            kComposite: 'legend.padding.left'
        }, 
        legendPaddingRight: {
            type: Number,
            kComposite: 'legend.padding.right'
        }, 
        legendPaddingTop: {
            type: Number,
            kComposite: 'legend.padding.top'
        }, 
        legendPosition: {
            type: String,
            kComposite: 'legend.position'
        }, 
        legendReverse: {
            type: Boolean,
            kComposite: 'legend.reverse'
        }, 
        legendVisible: {
            type: Boolean,
            kComposite: 'legend.visible'
        }, 
        legendWidth: {
            type: Number,
            kComposite: 'legend.width'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-charts-vue-wrapper/src/KendoChartBase/Legend.js